/*
const handleErrors = (response) => {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
};
*/
export const get_current_user = async () => {
  try {
    const response = await fetch('/rest/user/current', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });
    const response_json = await response.json();
    if (!response.ok && response.status !== 402) {
      throw response_json;
    }
    /*
      .then(handleErrors)
      .then((r) => r.json())
      .catch((err) => {
        console.error('Failed to get current user', err);
      });
    */
    return response_json;
  } catch (err_auth) {
    return { error: true, errors: [err_auth.message] };
  }
};

export const disconnect_user = async (all_devices = null) => {
  try {
    const disconnect_all = all_devices ? '?all_devices=true' : '';
    let response = await fetch(`/rest/user/logout${disconnect_all}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });
    const resp_json = await response.json();
    return resp_json;
  } catch (err_auth) {
    return { error: true, errors: [err_auth.message] };
  }
};

export const authenticate_user = async (email, password) => {
  const req_body = {
    email,
    password,
  };

  try {
    const res_login = await fetch('/rest/user/login', {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(req_body),
      method: 'POST',
      /*redirect: 'follow',*/
      mode: 'cors',
      credentials: 'include',
    });

    const res_login_json = await res_login.json();
    return res_login_json;
  } catch (err_login) {
    console.error('Failed to login', err_login);
    return { error: true, message: err_login };
  }
};

export const signup_user = async ({ account_type, firstname, lastname, email, phone, company, password, confirm_password, selected_plan }) => {
  const req_body = {
    account_type,
    firstname,
    lastname,
    email,
    company,
    password,
    confirm_password,
  };
  if (phone && phone.length > 0) {
    req_body.phone = phone;
  }
  if (selected_plan) {
    req_body.selected_plan = selected_plan;
  }

  try {
    const res_signup = await fetch('/rest/user/signup', {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(req_body),
      method: 'POST',
      /*redirect: 'follow',*/
      mode: 'cors',
      credentials: 'include',
    });

    const res_signup_json = await res_signup.json();
    return res_signup_json;
  } catch (err_signup) {
    console.error('Failed to signup', err_signup);
    return { error: true, details: err_signup };
  }
};

export const activate_user = async (email, code) => {
  try {
    let response = await fetch('/rest/user/activate', {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, code }),
    });
    if (response.ok) {
      const resp_json = await response.json();
      return resp_json;
    } else {
      const resp_json = await response.json();
      return { ok: false, errors: [resp_json.message] };
    }
  } catch (err_auth) {
    return { ok: false, errors: [err_auth.message] };
  }
};

export const get_new_activation_code = async (email) => {
  try {
    let response = await fetch(`/rest/user/new_activation_code?email=${email}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const resp_json = await response.json();
    return resp_json;
  } catch (err_auth) {
    return { error: true, errors: [err_auth.message] };
  }
};

export const delete_account = async () => {
  try {
    let response = await fetch('/rest/user', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });
    const resp_json = await response.json();
    return resp_json;
  } catch (err_auth) {
    return { error: true, errors: [err_auth.message] };
  }
};

export const forgot_user_password = async (email) => {
  const req_body = {
    email,
  };

  try {
    const res_forgot = await fetch('/rest/user/forgot', {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(req_body),
      method: 'PATCH',
      mode: 'cors',
      credentials: 'include',
    });

    const res_forgot_json = await res_forgot.json();
    return res_forgot_json;
  } catch (err_forgot) {
    console.error('Failed to forgot password', err_forgot);
    return { error: true, details: err_forgot };
  }
};

export const reset_user_password = async (code, new_password, confirm_password) => {
  const req_body = {
    token: code,
    newPassword: new_password,
    confirmPassword: confirm_password,
  };

  try {
    const res_signup = await fetch('/rest/user/reset', {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(req_body),
      method: 'PATCH',
      /*redirect: 'follow',*/
      mode: 'cors',
      credentials: 'include',
    });

    const res_signup_json = await res_signup.json();
    return res_signup_json;
  } catch (err_signup) {
    console.error('Failed to signup', err_signup);
    return { error: true, details: err_signup };
  }
};

export const change_user_password = async (old_password, new_password, confirm_password) => {
  const req_body = {
    old_password,
    new_password,
    confirm_password,
  };

  try {
    const res_signup = await fetch('/rest/user/change_password', {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(req_body),
      method: 'PATCH',
      /*redirect: 'follow',*/
      mode: 'cors',
      credentials: 'include',
    });

    const res_signup_json = await res_signup.json();
    return res_signup_json;
  } catch (err_signup) {
    console.error('Failed to signup', err_signup);
    return { error: true, details: err_signup };
  }
};
